var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',{staticStyle:{"margin-left":"35%","margin-top":"15%"}},[_vm._v(" This one is in to do list will have to start soon")])])}]

export { render, staticRenderFns }